/** @jsxImportSource @emotion/react */

import { Global } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

const GlobalStyles = () => {
  return (
    <Global
      styles={{
        html: {
          height: "100%",
          background: colors.white
        },

        body: {
          height: "100%",
          margin: 0,
          fontFamily: '"Inter", system-ui',
          overflowY: "hidden",
          overflowX: "hidden",

          "header + main": {
            width: "calc(100vw - 18px)"
          },

          "@media (max-width: 959px)": {
            "header + main, #root > footer": {
              width: "100%"
            }
          }
        },

        div: {
          scrollbarWidth: "thin",
          scrollbarColor: `${colors.blue200} transparent !important`
        },

        "#root": {
          minHeight: "100%",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          scrollbarColor: `${colors.blue200} transparent !important`
        },

        ".scrollable": {
          overflow: "auto",
          scrollbarColor: `${colors.blue200} transparent !important`
        },

        "main, .remaining-height": {
          display: "flex",
          flexDirection: "column",
          flex: "1"
        },

        "input[type='password']::-ms-reveal": {
          display: "none"
        },

        "h1, h2, h3, h4, h5, h6": {
          margin: 0,
          fontWeight: "unset"
        },

        ul: {
          margin: 0,
          padding: 0
        },

        li: {
          listStyle: "none"
        },

        a: {
          textDecoration: "none",
          color: "inherit",
          WebkitTapHighlightColor: "transparent"
        },

        button: {
          areaHidden: "false",

          inert: {
            pointerEvents: "auto",
            visibility: "visible"
          }
        },

        "*": {
          "&::-webkit-scrollbar": {
            width: "18px"
          },

          "&::-webkit-scrollbar-thumb": {
            backgroundColor: colors.blue200,
            borderRadius: "100px",
            border: `5px solid ${colors.white}`,
            minHeight: "60px"
          },

          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: colors.blue400
          }
        },

        "@keyframes pulsate": {
          "0%": {
            boxShadow: "0 0 0 0 rgba(0,63,180, 1)"
          },
          "50%": {
            boxShadow: "0 0 20px 0 rgba(0,63,180, 1)"
          },
          "100%": {
            boxShadow: "0 0 0 0 rgba(0,63,180, 1)"
          }
        },

        "@keyframes pulsateDot": {
          "0%": {
            transform: "scale(1)",
            transformOrigin: "center center"
          },
          "50%": {
            transform: "scale(1.4)",
            transformOrigin: "center center"
          },
          "100%": {
            transform: "scale(1)",
            transformOrigin: "center center"
          }
        },

        "@keyframes tutorialPulse": {
          "0%": {
            boxShadow:
              "0 0 0 0 rgba(166,200,255,0.7), 0 0 0 0 rgba(166,200,255,0.7)"
          },

          "40%": {
            boxShadow:
              "0 0 0 25px rgba(166,200,255,0), 0 0 0 0 rgba(166,200,255,0.7)"
          },

          "80%": {
            boxShadow:
              "0 0 0 25px rgba(166,200,255,0), 0 0 0 15px rgba(166,200,255,0)"
          },

          "100%": {
            boxShadow:
              "0 0 0 0 rgba(166,200,255,0), 0 0 0 15px rgba(166,200,255,0)"
          }
        },

        ".pulsating-circle": {
          animation: "pulsate 1.8s infinite",
          animationDelay: "0.5s"
        },

        ".pulsating-dot": {
          animation: "pulsateDot 1.8s infinite",
          animationDelay: "0.5s"
        },

        ".rs-picker-popup": {
          zIndex:
            "100" /* added a large random number to be sure that popup is displayed at the very top layer.*/
        }
      }}
    />
  );
};

export default GlobalStyles;
